module.exports = __webpack_public_path__ + "static/media/family.1f637794.png";